import { I18nContext } from "components/I18N";
import { useContext } from "react";

const Banner = ({
  backgroundImage,
  title,
  subtitle,
  children,
  footer = false,
}) => {
  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);

  const _height = footer ? 'lg:h-[70vh] h-[40vh]' : 'lg:h-[60vh] h-[30vh]'

  const checkEng = (text) => {
    return /^[A-Za-z][A-Za-z0-9]*$/.test(text)
  }

  return (
    <div
      className={`w-screen ${_height} relative bg-cover bg-center container-wrapper`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%] text-center	text-white w-full flex flex-col items-center" style={{ maxWidth: "calc(100% - 20px)" }}>
        {/* <div className="w-full h-[360px] lg:h-[520px] bg-[url('/images/homepage/bg.webp')] bg-center bg-cover bg-no-repeat flex-col row-center heading1 text-white font-extrabold"> */}
        {title && <p className={`heading5 font-extrabold mb-4`} dangerouslySetInnerHTML={{ __html: title }} />}
        {subtitle && <p className={`heading7 font-extrabold`} dangerouslySetInnerHTML={{ __html: subtitle }} />}
        {children}
      </div>
    </div>
  )
}

export default Banner